import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/pushed': {
    width: 432,
    height: 512,
    paths: [
      {
        d: 'M407 111.9c21.7 1.9 33.8 28 17.4 44.8l-235.2 231.3-35.3 80.8c-11 17.2-41.2 14.3-47.7-7l-105.1-348.3c-4.6-18.3 6.3-33.9 21.4-36.6l271.3-44.4c17.9-3.4 39.1 13.5 28.7 37l-14 33.4zM297.6 53.6l-189 31 177.4 16.3 16.8-39.9c2.3-4.9-0.1-8.1-5.2-7.4zM22.7 107.9l157.9 244.3 96.9-230.7-248.7-22.7c-5.1-0.9-9.2 4-6.1 9.1zM136 456.4c0 0 28.2-64.1 35.2-79.1l-127.7-197.6 83.1 275.5c1.5 4.3 6.8 5.2 9.4 1.2zM408.8 141.9c3.1-3.3 1.4-7.5-2.6-8.6l-106.4-9.7-89.7 213.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/pushed.js
// module id = 978
// module chunks = 0